import { isOpx, getOpxHostApiForRender, Feature } from 'owa-opx';

/**
 * Returns true if an OWA OPX is calling this disabled feature.
 * @param feature Name of the feature
 */
export function isFeatureDisabledForOpx(feature: Feature): boolean {
    return isOpx() && getOpxHostApiForRender().isFeatureDisabled(feature);
}
